import PosVendaService from "@/services/PosVendaService";
import VendaService from "@/services/VendaService";
import store from "@/store"
import moment from "moment"
export const actions = {
  cadastrarPosVenda: ({ commit, dispatch }) => {
    commit("setPosVenda", {
      id: "",
      proximo_contato: moment().add(3, 'days').format("YYYY-MM-DD"),
      venda_id: "",
    }),
      dispatch("setModalCadastroPosVenda", true);
  },
  listarPosVendas: ({ commit }, data) => {
    commit("setOverlay", true);
    PosVendaService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setPosVendas", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  async visualizarPosVenda({ commit, dispatch }, data) {
    commit("setPosVenda", { ...data });
    await VendaService.editar(data.venda_id)
      .then((res) => {
        commit("setVenda", res.data);
        dispatch("setModalVisualizarPosVenda", true);
      })
      .catch((e) => console.log(e));
    dispatch("setModalCadastroPosVenda", true);
  },
  salvarPosVenda: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    PosVendaService.salvar(data)
      .then((res) => {
        // commit('addPosVenda', res.data)
        commit("setPosVenda", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Pós-venda cadastrado.");
        dispatch("listarPosVendas", {});
        dispatch("setModalCadastroPosVenda", false);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarPosVenda: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    PosVendaService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Pós-venda atualizado.");
        dispatch("listarPosVendas", {});
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirPosVenda: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirPosVenda", false);
    dispatch("setModalCadastroPosVenda", false);
    PosVendaService.excluir(data.id)
      .then((res) => {
        dispatch("setModalVisualizarPosVenda", false);
        dispatch("listarPosVendas", {});
        commit("setOverlay", false);
        commit("snackbarError", "Pós-venda excluído.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir Pós-venda.");
      });
  },
  setModalCadastroPosVenda: ({ commit }, status) => {
    commit("setModalCadastroPosVenda", false);
    setTimeout(() => {
      commit("setModalCadastroPosVenda", status);
    }, 100);
  },
  setModalVisualizarPosVenda: ({ commit }, status) => {
    commit("setModalVisualizarPosVenda", false);
    setTimeout(() => {
      commit("setModalVisualizarPosVenda", status);
    }, 100);
  },
  setModalAtualizarTabelaPosVenda: ({ commit }, status) => {
    commit("setModalAtualizarTabelaPosVenda", false);
    setTimeout(() => {
      commit("setModalAtualizarTabelaPosVenda", status);
    }, 100);
  },
  setModalExcluirPosVenda: ({ commit }, status) => {
    commit("setModalExcluirPosVenda", false);
    setTimeout(() => {
      commit("setModalExcluirPosVenda", status);
    }, 100);
  },
  setModalFinalizarPosVenda: ({ commit }, status) => {
    commit("setModalFinalizarPosVenda", false);
    setTimeout(() => {
      commit("setModalFinalizarPosVenda", status);
    }, 100);
  },
  finalizarPosVenda: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    PosVendaService.finalizar(data)
    .then((res) => {
      dispatch("listarPosVendas", {});
      dispatch('setModalFinalizarPosVenda', false)
      commit('snackbarSuccess', 'Pós-venda finalizada com sucesso.')
      commit('setPosVenda', {...store.getters.getPosVenda, status: 'FINALIZADO'})
      commit("setOverlay", false);
    }).catch((e) => {
      console.log(e);
      commit("setOverlay", false);
    });
  },
};

export default {};
